<template>
  <div class="bak">
    <div class="gray100">
      <b-form-group label="문제유형">
        <b-form-radio-group
          @change="chgQType"
          v-model="q_type"
          :options="q_type_options"
          name="radio-q-type"
        ></b-form-radio-group>
      </b-form-group>
    </div>
    <b-form-group label-for="input-statement" label="지시문">
      <b-form-input
        :class="statement_valid_cls"
        id="input-statement"
        v-model="statement"
      ></b-form-input>
    </b-form-group>

    <div :class="title_valid_cls">
      <div>문제 *</div>
      <Editor
        ref="editor1"
        v-on:processing="appendAnswer"
        v-on:processing2="appendQType2Answer"
        v-on:processing3="appendQType3Answer"
        v-on:processing4="appendQType4Answer"
        func="updateQTitle"
        :content="title"
      />
    </div>

    <QType1Answer
      :answer="answer"
      v-bind:key="answer.id"
      v-for="answer in answers"
    />

    <b-row :class="nocount_qtype1_valid_cls">
      <b-col>
        <b-form-group>
          <b-button block size="sm" @click="appendAnswer('')">
            정답추가(+)
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <div>해석</div>
    <NormalEditor
      key="ned_1"
      ref="editor2"
      :content="translate"
      func="updateTranslate"
    />

    <div>해설</div>
    <NormalEditor
      key="ned_2"
      ref="editor3"
      :content="qcomment"
      func="updateQComment"
    />

    <b-row class="imagepanel">
      <b-col>
        <FileUpload utype="image" fileobj="image" v-if="image == ''" />
        <div v-else>
          <div>이미지</div>
          <div class="file-result">
            <img :src="image" class="preview" />
            <b-button size="sm" variant="danger" @click="removeimg()"
              >삭제</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>

    <VideoForm :video="video" :key="video.id" v-for="video in videos" />
    <b-row>
      <b-col>
        <b-form-group>
          <b-button block size="sm" @click="appendVideo">
            동영상추가(+)
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <FileUpload utype="sound" fileobj="sound" v-if="sound == ''" />

        <div v-else>
          <div>사운드</div>
          <div class="file-result">
            {{ sound }}
            <b-button size="sm" variant="danger" @click="removesnd()"
              >삭제</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>

    <LevelForm />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Editor from "@/components/Editor";
import NormalEditor from "@/components/NormalEditor";

import FileUpload from "@/components/FileUpload";
import VideoForm from "@/components/question/VideoForm";
import LevelForm from "@/components/question/LevelForm";

import QType1Answer from "@/components/question/QType1Answer";
export default {
  components: {
    Editor,
    NormalEditor,
    QType1Answer,
    FileUpload,
    VideoForm,
    LevelForm,
  },
  computed: {
    ...mapState("wriStore", ["q_type_options"]),
    answers() {
      return this.$store.state.qtype1_answers;
    },
    translate() {
      return this.$store.state.questionmeta.translate_imsi;
    },
    qcomment() {
      return this.$store.state.questionmeta.qcomment_imsi;
    },
    videos() {
      return this.$store.state.questionform.videos;
    },
    image() {
      return this.$store.state.questionform.image;
    },
    sound() {
      return this.$store.state.questionform.sound;
    },
  },
  methods: {
    nameWithLang({ d1, d2, d3 }) {
      return `${d1} -> ${d2} -> ${d3}`;
    },

    appendAnswer(seltext) {
      this.$store.dispatch("appendQType1Answer", seltext);
    },
    removeimg() {
      this.$store.commit("updateImage", "");
    },
    removesnd() {
      this.$store.commit("updateSound", "");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.bak {
  background-color: white;
  padding: 10px 15px 10px 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
}

.gray100 {
  background-color: $gray200;
  padding: 10px 15px 10px 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>